import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { getLatestPendingClassification, updateFormInstance } from '../../../reducers/formInstances';
import { TextAreaField } from '../../../components/fields';
import messages from '../../../text/messages';
import WizardButtons from '../../../components/wizard/navigator/buttons';
import { FormattedMessage } from 'react-intl';
import { Snackbar } from '../../../components/snackbar';

class AdminReviewTab extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        const { job, getLatestPendingClassification } = this.props;
        getLatestPendingClassification(job.id);
    }

    submit(values) {
        const { updateFormInstance } = this.props;
        updateFormInstance(values, () =>
            Snackbar.success(<FormattedMessage id={'approvalReviewSubmitted'} defaultMessage={'Approval notes successfully submitted.'} />)
        );
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <form onSubmit={handleSubmit(values => this.submit(values))}>
                <div className="row">
                    <div className="col-xs-12">
                        <Field name="notes_by_reviewer" component={TextAreaField} placeholder={messages.notes} hideErrors />
                    </div>
                </div>
                <div className="approval-tab-submit">
                    <WizardButtons submit={{ message: <FormattedMessage {...messages.updateNotes} /> }} />
                </div>
            </form>
        );
    }
}

AdminReviewTab = reduxForm({
    form: 'approval-admin-review-form',
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: false
})(AdminReviewTab);

const mapStateToProps = state => {
    let user = state.identity.profile;
    let classification = state.formInstances.classification;
    let initialValues = {};
    if (classification) {
        initialValues = { ...classification, reviewer: user ? user.id : undefined };
    }

    return {
        classification,
        admin: state.onboarding.admin,
        initialValues
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getLatestPendingClassification,
            updateFormInstance
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AdminReviewTab);



// WEBPACK FOOTER //
// ./src/pages/approval/tabs/adminReview.jsx